
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

// Import admin pages
import AdminDashboard from '@/pages/AdminDashboard';
import AdminSettings from '@/pages/AdminSettings';
import AdminUsers from '@/pages/AdminUsers';
import AdminCountries from '@/pages/AdminCountries';
import AdminInsights from '@/pages/AdminInsights';
import AdminAppearance from '@/pages/AdminAppearance';
import AdminCivicEducation from '@/pages/AdminCivicEducation';
import AdminIdentityDocs from '@/pages/AdminIdentityDocs';
import AdminPolls from '@/pages/AdminPolls';
import AdminCategories from '@/pages/AdminCategories';
import AdminSitemap from '@/pages/AdminSitemap';
import PollManagement from '@/pages/admin/PollManagement';
import DocumentPreview from '@/pages/DocumentPreview';
import AdminPointsManagement from '@/pages/admin/AdminPointsManagement';

export const adminRoutes = (
  <>
    <Route
      path="/admin/dashboard"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminDashboard />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/users"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminUsers />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/settings"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminSettings />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/countries"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminCountries />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/insights"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminInsights />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/appearance"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminAppearance />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/civic-education"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminCivicEducation />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/identity-docs"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminIdentityDocs />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/documents/:documentId"
      element={
        <ProtectedRoute requiredRole="admin">
          <DocumentPreview />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/polls"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminPolls />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/categories"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminCategories />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/sitemap"
      element={
        <ProtectedRoute requiredRole="admin">
          <AdminSitemap />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/poll-management"
      element={
        <ProtectedRoute requiredRole="admin">
          <PollManagement />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/points"
      element={
        <ProtectedRoute requiredRole="super_admin">
          <AdminPointsManagement />
        </ProtectedRoute>
      }
    />
  </>
);
